import { LoginModel } from '@core/model/login.model';

export class DataMessageModel {
    icon: any;
    labelTitile: string;
    textDescription: string;
    status: any;
    showResend: number;
    dataModel: any;
    screen: any;
    button: any;
    error: any;
    textIndication: any;
    textLink: any;
    ratingData: any;
    checked: boolean;

    //KFSC - 28-08-2021
    QtyCarrito: number;
    QtyRequerida: number;
    QtyDisponible: number;
    QtyEntregaInmediata: number;
    QtyDisponibleReabastece: number;
    QtyDias: number;
    IsKitItem: boolean;
    UpdateOption: boolean;
    //=================

    constructor() {
        this.icon = '';
        this.labelTitile = '';
        this.status = '';
        this.showResend = 0;
        this.textDescription = '';
        this.dataModel = '';
        this.screen = '';
        this.button = false;
        this.error = '';
        this.textIndication = '';
        this.textLink = '';
        this.ratingData = '';

        //KFSC - 28-08-2021
        this.QtyCarrito = 0;
        this.QtyRequerida = 0;
        this.QtyDisponible = 0;
        this.QtyEntregaInmediata = 0;
        this.QtyDisponibleReabastece = 0;
        this.QtyDias = 0;
        this.IsKitItem = false;
        this.UpdateOption = false;
        //=================
        this.checked = false;
    }
}
